import React from 'react'
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  return (
    <div className={`w-full h-12 xxl:h-20 flex gap-2 justify-center items-center ${isRTL ? 'rtl font-cairo' : 'ltr font-jakarta'}`}>
        <p className='font-medium text-[10px]  md:text-[14px] xxl:text-[16px] xxxxl:text-[22px] text-label'>{t('footer.title')} <a href='https://softcactus.ma' target='_blank' rel="noreferrer" className='text-primary font-bold'> SOFT CACTUS </a> </p>
        <p className='font-medium text-[10px]  md:text-[14px] xxl:text-[16px] xxxxl:text-[22px] text-label'> {t('footer.year')}</p>
    </div>
  )
}

export default Footer